// // src/components/ui/LoadingComponent.jsx
// import Lottie from "lottie-react";
// import Loader from "../../assets/lottie/Loader.json";

// const LoadingComponent = () => {
//   return (
//     <div className="d-flex justify-content-center align-items-center vh-100">
//       <div style={{ width: "250px" }}>
//         <Lottie animationData={Loader} loop={true} />
//       </div>
//     </div>
//   );
// };

// export default LoadingComponent;


import Lottie from "lottie-react";
import Loader from "../../assets/lottie/Loader.json";

const LoadingComponent = ({ variant = "table" }) => {
  const isTable = variant === "table";
  const isFullScreen = variant === "fullScreen";
  return (
    <>
      {isTable && (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div style={{ width: "250px" }}>
            <Lottie animationData={Loader} loop={true} />
          </div>
        </div>
      )}

      {isFullScreen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255,255,255,0.9)",
            zIndex: 99999,
            pointerEvents: "none",
          }}
        >
          <div style={{ width: "280px", maxWidth: "90vw", transform: "translateY(-10%)" }}>
            <Lottie animationData={Loader} loop={true} autoplay={true} />
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingComponent;